import React from "react";

export default function VanOverlay({ phase }) {
  if (!phase) return null;
  return (
    <img
      src={phase === "open" || phase === "grab" ? "/vanopen.png" : "/van.png"}
      alt=""
      className={`van-anim ${phase === "enter" ? "van-enter" : phase === "drive" ? "van-drive" : "van-stopped"}`}
      draggable={false}
    />
  );
}
